import { INTERNAL_STATUS, STATUS } from 'omega-rtc/constants/ucd';

type JourneyCampaignStatus = {
  isPendingApproval?: boolean;
  status?: string;
};

type JourneyCampaignResponse = JourneyCampaignStatus & {
  campaign?: JourneyCampaignStatus;
};

// Normal UCD campaigns keep status=DRAFT while approval is pending. Derive a
// UI-only status from the flag; never send this derived value in an edit request.
export const getJourneyCampaignDisplayStatus = (
  response?: JourneyCampaignResponse,
  details = response && (response.campaign || response),
): string => {
  const status = ((response && response.status) || (details && details.status) || '')
    .trim().toUpperCase().replace(/\s+/g, '_');
  const isPendingApproval = details && typeof details.isPendingApproval === 'boolean'
    ? details.isPendingApproval : response && response.isPendingApproval;
  if (status === INTERNAL_STATUS.draft && isPendingApproval === true) {
    return STATUS.pendingApproval;
  }
  return status;
};
